/** Stable sentinel for unfiltered / "all" options in filter dropdowns. */
export const FILTER_ALL = 'all' as const;
